// --- Our Modules --------------------------------------------------------------------------------
import Icon from "@/UI/atoms/Icon";
import type { TyIconName } from "@/UI/atoms/Icon/types";
import "./styles.css";
// --- Logic --------------------------------------------------------------------------------------
export type TyAction = { key: string; label: string; icon: TyIconName; danger?: boolean; onSelect: () => void };
export type TyActionsDetails = { actions: TyAction[] };

type Props = { onClose: () => void; details?: unknown };

/** The generic "more actions" menu. Anchored under whatever opened it; every section reuses it. */
export default function ActionsPopup({ onClose, details }: Props) {
    const actions = (details as TyActionsDetails | undefined)?.actions ?? [];

    const handle = (action: TyAction) => {
        onClose();
        action.onSelect();
    };

    return (
        <menu className="popup-card actions-popup">
            {actions.map((action) => (
                <li key={action.key}>
                    <button
                        type="button"
                        className={`actions-popup__item${action.danger ? " actions-popup__item--danger" : ""}`}
                        onClick={() => handle(action)}
                    >
                        <Icon name={action.icon} size={18} />
                        <span>{action.label}</span>
                    </button>
                </li>
            ))}
        </menu>
    );
}
